import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/chadcn/Dialog"

type MealInfoModalProps = {
  open: boolean
  onClose: () => void
}

const MealInfoModal = ({ open, onClose }: MealInfoModalProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle className="sr-only">About logging meals</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-4 text-base font-medium text-primary-contrast">
        <p>
          Carbohydrates affect your blood sugar more than proteins and fats.
          Counting carbohydrates allows you to track the sugar and starch in
          the foods you are eating and monitor how those foods affect your
          blood sugar levels.
        </p>
        <p>
          Your doctor may recommend taking a measurement that captures how
          your blood sugar levels increase directly after a meal —
          approximately one hour after your first bite. Or your doctor may
          recommend taking a measurement that captures how your blood sugar
          levels recover after a meal — approximately two hours after your
          first bite. Be sure to follow your doctor&apos;s instructions to
          determine the right timing for you.
        </p>
        <p>
          Every body digests and processes different foods in their own
          unique ways. Closely tracking your personal ups and downs will help
          you and your clinicians understand how your body responds to
          certain foods and adapt your food plan.
        </p>
      </div>
    </DialogContent>
  </Dialog>
)

export default MealInfoModal
